import { render, staticRenderFns } from "./CMSBlogTagList.vue?vue&type=template&id=54ab1b48&"
import script from "./CMSBlogTagList.vue?vue&type=script&lang=js&"
export * from "./CMSBlogTagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports